import { useState } from "react";

const faqs = [
  {
    q: "How do I get an expedited passport in Bismarck, North Dakota?",
    a: "Bismarck residents can use Fast Passport Center for 2–9 day expedited processing. Ship documents overnight and we handle agency submission remotely. The nearest regional agency is in Denver at 650+ miles, or Chicago at 700+ miles — our service eliminates that trip entirely.",
  },
  {
    q: "Where is the nearest passport agency to Bismarck, ND?",
    a: "The Denver Regional Passport Agency (1961 Stout St, Denver, CO) is approximately 650+ miles south of Bismarck. The Chicago agency is about 700 miles east. Both require appointments for genuine life-or-death emergencies only. Fast Passport Center provides expedited processing without any travel required.",
  },
  {
    q: "How long does passport processing take from Bismarck?",
    a: "With Fast Passport Center, 2–9 days. Standard post office expedited processing takes 3–5 weeks, and routine processing takes 6–11 weeks. Given Bismarck's remote location relative to regional agencies, our courier service is the fastest practical option.",
  },
  {
    q: "Which post offices in Bismarck accept passport applications?",
    a: "The Bismarck Main Post Office (220 E Rosser Ave), Bismarck South Post Office (1640 E Divide Ave), the Burleigh County Clerk of Courts, and the Mandan Post Office all accept passport applications. We'll tell you exactly which facility and what to bring.",
  },
  {
    q: "Can state government employees in Bismarck use your service?",
    a: "Absolutely. Fast Passport Center regularly serves North Dakota state government employees, contractors, and officials in Bismarck who need passports for domestic travel, international conferences, and official duties. Our service is available to everyone.",
  },
  {
    q: "Do I need to travel to Denver for an emergency passport from Bismarck?",
    a: "Only if you have a documented life-or-death emergency AND travel within 72 hours. For all other urgent situations — including trips within 2–3 weeks — Fast Passport Center provides expedited processing without a 650-mile drive to Denver.",
  },
  {
    q: "How much does expedited passport service cost in Bismarck?",
    a: "The government fee is $60 for expedited renewal ($130 for new passports) plus a $35 execution fee if submitting in person. Fast Passport Center charges an additional service fee for courier and agent services. Contact us for a complete quote based on your situation.",
  },
  {
    q: "Can Mandan residents use your service for passport processing?",
    a: "Yes! Mandan, Lincoln, Wilton, Steele, and all other Burleigh County communities are fully covered. The Mandan Post Office (300 W Main St) is a convenient acceptance facility for west side residents, and we coordinate with all local acceptance facilities.",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Bismarck Passport Questions Answered
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base leading-relaxed">
            Everything Bismarck and Burleigh County residents need to know about expedited passport services.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-[#F7F8FA] transition-colors"
              >
                <span className="font-semibold text-[#1A365D] text-sm pr-4">{faq.q}</span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className={`${openIndex === i ? "ri-subtract-line" : "ri-add-line"} text-[#F6C344] text-lg`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5 text-sm text-gray-500 leading-relaxed border-t border-gray-100 pt-4">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((faq) => ({
              "@type": "Question",
              name: faq.q,
              acceptedAnswer: { "@type": "Answer", text: faq.a },
            })),
          }),
        }}
      />
    </section>
  );
}